module.exports = __webpack_public_path__ + "static/media/19-13.6c25cb26.mp3";